"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importStar(require("react"));
const slider_module_scss_1 = __importDefault(require("./slider.module.scss"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_utilities_hooks_use_debounce_1 = require("@campgladiator/cgui-core.utilities.hooks.use-debounce");
const DEFAULT_MAX_RANGE_VALUE = 96;
const DEFAUL_MIN_RANGE_VALUE = 0;
function Slider({ onChange, onClick = () => { }, maxRangeValue = DEFAULT_MAX_RANGE_VALUE, initialMinValue = DEFAUL_MIN_RANGE_VALUE, initialMaxValue = DEFAULT_MAX_RANGE_VALUE, disabled = false, reset, }) {
    const [minValue, setMinValue] = (0, react_1.useState)(initialMinValue);
    const [maxValue, setMaxValue] = (0, react_1.useState)(initialMaxValue);
    const debounceOnChange = (0, react_1.useCallback)((0, cgui_core_utilities_hooks_use_debounce_1.useDebounce)(({ minValue, maxValue }) => {
        onChange({
            minValue,
            maxValue,
        });
    }, 100), [minValue, maxValue, onChange]);
    const handleMinValueChange = (0, react_1.useCallback)((event) => {
        const newMinValue = Math.min(parseInt(event.target.value), maxValue - 1);
        setMinValue(newMinValue);
        debounceOnChange({
            minValue: newMinValue,
            maxValue,
        });
    }, [debounceOnChange, maxValue]);
    const handleMaxValueChange = (0, react_1.useCallback)((event) => {
        const newMaxValue = Math.max(parseInt(event.target.value), minValue + 1);
        setMaxValue(newMaxValue);
        debounceOnChange({
            minValue,
            maxValue: newMaxValue,
        });
    }, [debounceOnChange, minValue]);
    (0, react_1.useEffect)(() => {
        if (reset !== undefined) {
            setMinValue(0);
            setMaxValue(maxRangeValue);
            onChange({
                minValue: 0,
                maxValue: maxRangeValue,
            });
        }
    }, [reset]);
    return (react_1.default.createElement("div", { className: slider_module_scss_1.default.container },
        react_1.default.createElement("div", { className: slider_module_scss_1.default.content },
            react_1.default.createElement("input", { type: "range", min: 0, max: maxRangeValue, value: minValue, onChange: handleMinValueChange, className: slider_module_scss_1.default.input, disabled: disabled, onClick: onClick }),
            react_1.default.createElement("input", { type: "range", min: 0, max: maxRangeValue, value: maxValue, onChange: handleMaxValueChange, className: slider_module_scss_1.default.input, disabled: disabled, onClick: onClick }),
            react_1.default.createElement("div", { className: slider_module_scss_1.default.rangeBarBase }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(slider_module_scss_1.default.rangeBar), "data-type-disabled": disabled, style: {
                    width: `calc(${(maxValue - minValue) * 1}% - 4px)`,
                    left: `calc(${minValue * 1}% + 2px)`,
                } }))));
}
exports.Slider = Slider;
//# sourceMappingURL=slider.js.map